import { render } from "./AccountMenu.vue?vue&type=template&id=c27d5330&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"

import "./AccountMenu.vue?vue&type=style&index=0&id=c27d5330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27d5330"]])

export default __exports__